<script lang="ts">
	import "ckeditor5/ckeditor5-content.css";
	import type { ClassValue } from "svelte/elements";
	import { transformCkEditorContent } from "@core/utils/transformCkEditorContent.js";

	const {
		html,
		class: customClass,
		lightboxId = "content",
	}: {
		html: string;
		class?: ClassValue;
		lightboxId?: string;
	} = $props();

	/* eslint-disable svelte/no-at-html-tags */
</script>

<div class={["ckeditor-content", customClass]}>
	{@html transformCkEditorContent(html, lightboxId)}
</div>
